var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserUpload = function SvgUserUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20 59a1 1 0 0 1 1-1h38a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1M40.707 19.293a1 1 0 0 0-1.414 0l-6.364 6.364a1 1 0 0 0 1.414 1.414L39 22.414V50a1 1 0 1 0 2 0V22.414l4.657 4.657a1 1 0 0 0 1.414-1.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10 11a1 1 0 0 1 1-1h58a1 1 0 0 1 1 1v58a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1zm2 1v56h56V12z",
    clipRule: "evenodd"
  })));
};
export default SvgUserUpload;